import "src/decidim/elections/waiting_room.js";
import "src/decidim/elections/live_results_update.js";
require.context("../images", true);
import "entrypoints/decidim_elections.scss";
